import { ExponentBoxIcon } from './ExponentBoxIcon';

/**
 * author: Nick
 * id F061DE5C-F495-4EDF-BD16-DAD6B07605BC
 * name exponent-box
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/exponent-box.svg
 * tags
 * - Math 
 */
export const PowerBoxIcon = ExponentBoxIcon;
export default PowerBoxIcon